import React, { Component, Fragment } from 'react';
import axios from 'axios';
import {
    Table,
    Form,
    Icon,
    Button,
    Loader,
    Input, Popup, Segment
} from 'semantic-ui-react';
import { fetchFaculties } from '../../Lookups/util';
import { fetchUserOrganizationalUnit } from '../../Assets/util/roles';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';

class ExternalStudentFaculties extends Component {
    constructor(props) {
        super(props);
        this.state = {
            student: props.student,
            data: [],
            faculties: [],
            loading: true,
            editingRowId: null,
            editedRowData: null,
            saving: false,
            isAdding: false,
            isDeleting: false,
            deletingRowId: null,
            userOrganizationalUnitId: null,
            isMainOU: false,

            organizationalUnitErr: false,
        };
    }

    componentDidMount() {
        this.fetchInitialData();
    }

    fetchInitialData = () => {
        this.setState({
            loading: true,
            errorFetchingData: false
        });

        Promise.all([
            fetchFaculties(),
            axios.get(`/external-student-organization-unit/external-student/${this.props.externalStudentId}`),
            fetchUserOrganizationalUnit(),
        ])
            .then(([facultiesResponse, studentOrgUnitsResponse, userOrganizationalUnitResponse]) => {
                const faculties = facultiesResponse.data.map(faculty => ({
                    key: faculty.id,
                    value: faculty,
                    text: faculty.name
                }));
                this.setState({
                    faculties,
                    data: studentOrgUnitsResponse.data,
                    loading: false
                });
                if (userOrganizationalUnitResponse) {
                    // console.log('User Organizational Unit:');
                    // console.log(userOrganizationalUnitResponse.data);
                    this.setState({ userOrganizationalUnitId: userOrganizationalUnitResponse.data });
                }
                const isMainOU = studentOrgUnitsResponse.data.some(entry =>
                    entry.mainOrganizationalUnit &&
                    entry.organizationalUnit &&
                    entry.organizationalUnit.id === userOrganizationalUnitResponse.data
                );
                this.setState({ isMainOU });
            })
            .catch(error => {
                // console.error('Greška pri dohvaćanju podataka:', error);
                toast(<FormattedMessage id="externalStudent.toast.errorFetchingData"/>);
                this.setState({
                    loading: false,
                    errorFetchingData: true
                });
            });
    };

    handleDeleteClick = (entry) => {
        this.setState({
            isDeleting: true,
            deletingRowId: entry.id
        });
    };

    handleEditClick = (entry) => {
        this.setState({
            organizationalUnitErr: false,
            editingRowId: entry.id,
            editedRowData: { ...entry }
        });
    };

    handleCancelClick = () => {
        const {
            isAdding,
            editingRowId,
            data
        } = this.state;
        const newData = isAdding
            ? data.filter(d => d.id !== editingRowId)
            : data;

        this.setState({
            data: newData,
            editingRowId: null,
            editedRowData: null,
            isAdding: false,
            isDeleting: false,
            deletingRowId: null,
        });
    };

    handleConfirmClick = () => {
        const {
            editedRowData,
            data,
            isAdding,
            isDeleting,
            deletingRowId
        } = this.state;
        this.setState({ saving: true });

        if (!isDeleting) {
            // validation
            // console.log(editedRowData);
            // organizationalUnit is required
            if (!editedRowData.organizationalUnit) {
                this.setState({ organizationalUnitErr: true });
                // console.log('Organizational unit is required:', editedRowData);
                toast(<FormattedMessage id="externalStudent.toast.requireFaculty"/>);
                // toast('Unos fakulteta je obavezan.');
                this.setState({ saving: false });
                return;
            }

            const sameOUCount = data.filter(
                d => d.organizationalUnit
                    && d.organizationalUnit.id === editedRowData.organizationalUnit.id
                    && d.id !== editedRowData.id).length;
            if (sameOUCount !== 0) {
                this.setState({ organizationalUnitErr: true });
                toast(<FormattedMessage id="externalStudent.toast.duplicateOrganizationalUnit"/>);
                // toast('Nije moguće dodati istu organizacionu jedinicu više puta!');
                this.setState({ saving: false });
                return;
            }

            // there must be only one main organizational unit
            if (editedRowData.mainOrganizationalUnit) {
                const mainOUCount = data.filter(d => d.mainOrganizationalUnit && d.id !== editedRowData.id).length;
                if (mainOUCount > 0) {
                    // console.log('There is already a main organizational unit:', editedRowData);
                    toast(<FormattedMessage id="externalStudent.toast.singleMainOrganizationalUnit"/>);
                    // toast('Samo jedna organizaciona jedinica može biti glavna.');
                    this.setState({ saving: false });
                    return;
                }
            }
        }

        const payload =
            isDeleting ? {} : {
                organizationalUnitId: editedRowData.organizationalUnit.id,
                externalStudentId: this.props.externalStudentId,
                studentIdentificationNumber: editedRowData.studentIdentificationNumber || '',
                contactPersonFirstName: editedRowData.contactPersonFirstName || '',
                contactPersonLastName: editedRowData.contactPersonLastName || '',
                contactPersonEmail: editedRowData.contactPersonEmail || '',
                contactPersonPhone: editedRowData.contactPersonPhone || '',
                // dataEntryCompleted: true,
                mainOrganizationalUnit: editedRowData.mainOrganizationalUnit || false
            };
        let axiosCall = null;
        if (isDeleting) {
            axiosCall = axios.delete(`/external-student-organization-unit/${deletingRowId}`);
        } else if (isAdding) {
            axiosCall = axios.post('/external-student-organization-unit/', payload);
        } else {
            axiosCall = axios.put(`/external-student-organization-unit/`, {
                ...payload,
                id: editedRowData.id
            });
        }

        axiosCall
            .then(response => {
                // osvjezi podatke
                axios.get(`/external-student-organization-unit/external-student/${this.props.externalStudentId}`)
                    .then(response => {
                        const updatedData = response.data;
                        this.setState({
                            data: updatedData,
                            editingRowId: null,
                            editedRowData: null,
                            saving: false,
                            isAdding: false,
                            isDeleting: false,
                            deletingRowId: null,
                        });

                        if (isAdding) {
                            toast(<FormattedMessage id="externalStudent.toast.facultyAdded"/>);
                            // toast('Fakultet uspješno dodan.');
                        } else if (isDeleting) {
                            toast(<FormattedMessage id="externalStudent.toast.facultyDeleted"/>);
                            // toast('Fakultet uspješno obrisan.');
                        } else {
                            toast(<FormattedMessage id="externalStudent.toast.facultyUpdated"/>);
                            // toast('Fakultet uspješno ažuriran.');
                        }
                    });
                /*
                const saved = response.data;
                const updatedData = isAdding
                    ? [saved, ...data.slice(1)]
                    : data.map(d => d.id === editingRowId ? editedRowData : d);

                this.setState({
                    data: updatedData,
                    editingRowId: null,
                    editedRowData: null,
                    saving: false,
                    isAdding: false,
                });
                */
            })
            .catch(error => {
                this.setState({ saving: false });

                if (isDeleting) {
                    const msg = error && error.response && error.response.data ? error.response.data : '';
                    if (msg.includes('ConstraintViolationException')) {
                        toast(<FormattedMessage id="externalStudent.toast.facultyDeleteErrorLinked"/>);
                        // toast('Nije moguće obrisati fakultet sve dok je student u mobilnosti upisan na predmet sa tog fakulteta!');
                    } else {
                        toast(<FormattedMessage id="externalStudent.toast.facultyDeleteError"/>);
                        // toast('Greška pri brisanju fakulteta!');
                    }
                } else {
                    toast(<FormattedMessage id="externalStudent.toast.saveError"/>);
                    // toast('Greška pri spremanju podataka!');
                }
            });
    };

    handleInputChange = (field, value) => {
        this.setState(prevState => ({
            editedRowData: {
                ...prevState.editedRowData,
                [field]: value
            }
        }), () => {
            if (field === 'studyProgramId') {
                this.fetchCoursesByStudyProgram(value);
            }
        });
    };

    handleAddClick = () => {
        const newRow = {
            /*
            id: `new-${Date.now()}`,
            externalStudent: { id: this.props.externalStudentId },
            organizationalUnit: {
                id: null,
                name: ''
            },
            studentIdentificationNumber: '',
            contactPersonFirstName: '',
            contactPersonLastName: '',
            contactPersonEmail: '',
            contactPersonPhone: '',
            dataEntryCompleted: true,
            mainOrganizationalUnit: false
             */
        };

        this.setState(prevState => ({
            organizationalUnitErr: false,
            data: [newRow, ...prevState.data],
            editingRowId: newRow.id,
            editedRowData: newRow,
            isAdding: true
        }));
    };

    getFacultyValueById = (id) => {
        const found = this.state.faculties.find(f => f.value.id === id);
        return found ? found.value : null;
    };

    addDays = (date, days) => {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    };

    render() {
        const {
            data,
            faculties,
            loading,
            editingRowId,
            editedRowData,
            saving,
            isAdding,
            isDeleting,
            deletingRowId,
            organizationalUnitErr,
            isMainOU,
            errorFetchingData
        } = this.state;

        const localStorageRole = localStorage.getItem('activeRole') || '';
        const isAdmin = localStorageRole === 'Administrator' || localStorageRole === 'AIDA';
        const isInternationalCooperationService = localStorageRole === 'Služba za međunarodnu saradnju';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';

        if (errorFetchingData) {
            return <Segment textAlign={'center'}>
                <Button basic onClick={() => this.fetchInitialData()}>
                    <FormattedMessage id={'externalStudent.loadAgain'}/>
                </Button>
            </Segment>;
        }


        if (loading) {
            return <div style={{
                paddingTop: '100px',
                paddingBottom: '100px'
            }}><Loader active inline="centered"/></div>;
        }

        return (
            <Form>
                <Table selectable celled compact textAlign={'left'} verticalAlign={'middle'}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell width={1}><FormattedMessage
                                id="externalStudent.ordinalNumber"/></Table.HeaderCell>
                            <Table.HeaderCell width={4}><FormattedMessage
                                id="externalStudent.facultyName"/></Table.HeaderCell>
                            <Table.HeaderCell width={2}><FormattedMessage
                                id="externalStudent.indexNumber"/></Table.HeaderCell>
                            <Table.HeaderCell width={2}><FormattedMessage
                                id="externalStudent.contactFirstName"/></Table.HeaderCell>
                            <Table.HeaderCell width={2}><FormattedMessage
                                id="externalStudent.contactLastName"/></Table.HeaderCell>
                            <Table.HeaderCell width={3}><FormattedMessage
                                id="externalStudent.contactEmail"/></Table.HeaderCell>
                            <Table.HeaderCell width={2}><FormattedMessage
                                id="externalStudent.contactPhone"/></Table.HeaderCell>
                            {/*<Table.HeaderCell width={2}>Unos podataka završen</Table.HeaderCell>*/}
                            <Table.HeaderCell width={2}><FormattedMessage id="externalStudent.mainOrganizationalUnit"/></Table.HeaderCell>
                            {
                                (isInternationalCooperationService || isStudentService) &&
                                (<Table.HeaderCell width={2} textAlign="center">
                                    {(isInternationalCooperationService || (isStudentService && isMainOU)) &&
                                        (<Popup
                                            content={<FormattedMessage id="externalStudent.add"/>}
                                            position="top center"
                                            trigger={<Button
                                                basic
                                                circular
                                                icon
                                                size="tiny"
                                                color="blue"
                                                onClick={this.handleAddClick}
                                                disabled={this.state.student.lockedAt || this.state.student.dropoutDate || loading || editingRowId !== null || isAdding || isDeleting /*|| this.state.student.dateTo < this.addDays(new Date(), -15)*/}
                                            >
                                                <Icon name="plus"/>
                                            </Button>}/>)
                                    }
                                </Table.HeaderCell>)
                            }
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {data.map((entry, index) => {
                            const isEditing = entry.id === editingRowId;
                            const current = isEditing ? editedRowData : entry;

                            return (
                                <Table.Row key={entry.id} verticalAlign={'middle'}
                                           positive={entry.mainOrganizationalUnit}>
                                    <Table.Cell verticalAlign={'middle'}>{index + 1}.</Table.Cell>
                                    <Table.Cell verticalAlign={'middle'}>
                                        {
                                            isEditing && (isInternationalCooperationService || (isAdding && isMainOU)) ? (
                                                    <Form.Select
                                                        fluid
                                                        options={faculties}
                                                        value={this.getFacultyValueById(
                                                            current.organizationalUnit && current.organizationalUnit.id
                                                        )}
                                                        placeholder={<FormattedMessage id="externalStudent.selectFaculty"/>}
                                                        clearable
                                                        selection
                                                        search
                                                        error={organizationalUnitErr}
                                                        onChange={(e, { value }) => {
                                                            // console.log('SELECTED VALUE:', value);
                                                            this.handleInputChange('organizationalUnit', value);
                                                        }}
                                                    />
                                                ) :
                                                <Fragment>
                                                    {/*entry.mainOrganizationalUnit && (<Icon color={'blue'} name="certificate"/>)*/}
                                                    {entry.organizationalUnit.name}
                                                </Fragment>
                                        }
                                    </Table.Cell>
                                    <Table.Cell verticalAlign={'middle'}>
                                        {isEditing && (isInternationalCooperationService || isStudentService) ? (
                                            <FormattedMessage id="externalStudent.enterIndexNumber">
                                                {msg => (
                                                    <Input
                                                        fluid
                                                        placeholder={msg}
                                                        value={current.studentIdentificationNumber || ''}
                                                        onChange={(e) => this.handleInputChange('studentIdentificationNumber', e.target.value)}
                                                    />
                                                )}
                                            </FormattedMessage>
                                        ) : (
                                            entry.studentIdentificationNumber || ''
                                        )}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign={'middle'}>
                                        {isEditing && (isInternationalCooperationService || isStudentService) ? (
                                            <FormattedMessage id="externalStudent.enterContactPersonFirstName">
                                                {msg => (
                                                    <Input
                                                        fluid
                                                        placeholder={msg}
                                                        value={current.contactPersonFirstName || ''}
                                                        onChange={(e) => this.handleInputChange('contactPersonFirstName', e.target.value)}
                                                    />
                                                )}
                                            </FormattedMessage>
                                        ) : (
                                            current.contactPersonFirstName || ''
                                        )}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign={'middle'}>
                                        {isEditing && (isInternationalCooperationService || isStudentService) ? (
                                            <FormattedMessage id="externalStudent.enterContactPersonLastName">
                                                {msg => (
                                                    <Input
                                                        fluid
                                                        placeholder={msg}
                                                        value={current.contactPersonLastName || ''}
                                                        onChange={(e) => this.handleInputChange('contactPersonLastName', e.target.value)}
                                                    />
                                                )}
                                            </FormattedMessage>
                                        ) : (
                                            current.contactPersonLastName || ''
                                        )}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign={'middle'}>
                                        {isEditing && (isInternationalCooperationService || isStudentService) ? (
                                            <FormattedMessage id="externalStudent.enterContactPersonEmail">
                                                {msg => (
                                                    <Input
                                                        fluid
                                                        placeholder={msg}
                                                        value={current.contactPersonEmail || ''}
                                                        onChange={(e) => this.handleInputChange('contactPersonEmail', e.target.value)}
                                                    />
                                                )}
                                            </FormattedMessage>
                                        ) : (
                                            current.contactPersonEmail || ''
                                        )}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign={'middle'}>
                                        {isEditing && (isInternationalCooperationService || isStudentService) ? (
                                            <FormattedMessage id="externalStudent.enterContactPersonPhone">
                                                {msg => (
                                                    <Input
                                                        fluid
                                                        placeholder={msg}
                                                        value={current.contactPersonPhone || ''}
                                                        onChange={(e) => this.handleInputChange('contactPersonPhone', e.target.value)}
                                                    />
                                                )}
                                            </FormattedMessage>
                                        ) : (
                                            current.contactPersonPhone || ''
                                        )}
                                    </Table.Cell>
                                    <Table.Cell textAlign="center" verticalAlign={'middle'}>
                                        {
                                            isEditing && isInternationalCooperationService ? (
                                                    <Form.Checkbox
                                                        checked={current.mainOrganizationalUnit || false}
                                                        onChange={(e, { checked }) => this.handleInputChange('mainOrganizationalUnit', checked)}
                                                    />

                                                ) :
                                                entry.mainOrganizationalUnit ? (
                                                    <FormattedMessage id="common.yes"/>
                                                ) : (
                                                    <FormattedMessage id="common.no"/>
                                                )
                                        }
                                    </Table.Cell>
                                    {(isInternationalCooperationService || isStudentService) && (
                                        <Table.Cell textAlign="center" verticalAlign={'middle'}>
                                            {isEditing || (isDeleting && deletingRowId === entry.id) ? (
                                                <Fragment>
                                                    <Popup
                                                        content={<FormattedMessage id="externalStudent.save"/>}
                                                        position="top center"
                                                        trigger={<Button
                                                            circular
                                                            icon
                                                            size="tiny"
                                                            color="blue"
                                                            onClick={this.handleConfirmClick}
                                                            loading={saving}
                                                            disabled={saving}
                                                        >
                                                            <Icon name="check"/>
                                                        </Button>}/>
                                                    <Popup
                                                        content={<FormattedMessage id="externalStudent.cancel"/>}
                                                        position="top center"
                                                        trigger={<Button
                                                            basic
                                                            circular
                                                            icon
                                                            size="tiny"
                                                            color="blue"
                                                            onClick={this.handleCancelClick}
                                                            disabled={saving}
                                                        >
                                                            <Icon name="close"/>
                                                        </Button>}/>
                                                </Fragment>
                                            ) : (
                                                <Fragment>
                                                    {(isInternationalCooperationService || (isStudentService && (this.state.userOrganizationalUnitId === current.organizationalUnit.id || isMainOU))) &&
                                                        (<Popup
                                                            content={<FormattedMessage id="externalStudent.edit"/>}
                                                            position="top center"
                                                            trigger={<Button
                                                                basic
                                                                circular
                                                                icon
                                                                disabled={this.state.student.lockedAt || this.state.student.dropoutDate || isAdding || (isDeleting && deletingRowId !== entry.id) || (editingRowId && editingRowId !== entry.id) /*|| this.state.student.dateTo < this.addDays(new Date(), -15)*/}
                                                                size="tiny"
                                                                color="green"
                                                                onClick={() => this.handleEditClick(entry)}
                                                            >
                                                                <Icon name="pencil"/>
                                                            </Button>}/>)
                                                    }

                                                    {(isInternationalCooperationService || (isStudentService && (this.state.userOrganizationalUnitId !== current.organizationalUnit.id && isMainOU))) &&
                                                        (<Popup
                                                            content={<FormattedMessage id="externalStudent.delete"/>}
                                                            position="top center"
                                                            trigger={<Button
                                                                basic
                                                                circular
                                                                icon
                                                                disabled={this.state.student.lockedAt || this.state.student.dropoutDate || isAdding || (isDeleting && deletingRowId !== entry.id) || (editingRowId && editingRowId !== entry.id) /*|| this.state.student.dateTo < this.addDays(new Date(), -15)*/}
                                                                size="tiny"
                                                                color="red"
                                                                onClick={() => this.handleDeleteClick(entry)}
                                                            >
                                                                <Icon name="trash alternate"/>
                                                            </Button>}/>)}
                                                </Fragment>
                                            )}
                                        </Table.Cell>)}
                                </Table.Row>
                            );
                        })}
                        {data.length === 0 && (
                            <Table.Row>
                                <Table.Cell
                                    textAlign={'left'}
                                    colSpan={(localStorageRole !== 'Služba za međunarodnu saradnju' && localStorageRole.slice(0, 10) !== 'Studentska') ? 8 : 9}>
                                    {<FormattedMessage id="externalStudent.noFaculties"/>}
                                </Table.Cell>
                            </Table.Row>
                        )}
                    </Table.Body>
                </Table>
            </Form>
        );
    }
}

export default ExternalStudentFaculties;



// WEBPACK FOOTER //
// ./src/views/ExternalStudents/ExternalStudentProfile/ExternalStudentFaculties.js